export default "__VITE_ASSET__DlUV6ImQ__"